import React, { useState, useRef,useEffect } from 'react';
import { useParams,useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { GetSingleBank, LedgerEntires } from '../store/slices/bankbook';
import Table from '../common/Table';
import Loader from '../common/Loader';
import AdminLayout from './AdminLayout';
import { FaFileExcel ,FaFilePdf} from 'react-icons/fa';
import { toast } from 'react-hot-toast';
import { excelBankBookDownload } from '../common/ExcelDownload';
import {API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";

const BankBook = () => {
  const { id } = useParams();
  const NewID = id;
  const dispatch = useDispatch();
    const navigate = useNavigate();
  const tableRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [bankData, setBankData] = useState();
  const [ledgerEntires, setLedgerEntires] = useState();
  const [selectedRows, setSelectedRows] = useState([]); // Stores selected row IDs
  const [selectAll, setSelectAll] = useState(false);

  const user = JSON.parse(localStorage.getItem('user'));
  const profile_id = user?.data?.profile_id;
  const item = { profile_id: profile_id, ledger_id: id };

  const [columns, setcolumns] = useState([
    { header: 'Checkbox', field: 'Checkbox' },
    { header: 'Description', field: 'description', isMultiline: true },
    { header: 'Date', field: 'ledger_date', isDate: true },
    { header: 'Dr', field: 'dr', isDrCr: true, isDr: true },
    { header: 'Cr', field: 'cr', isDrCr: true, isDr: false },
    { header: 'Closing Balance', field: 'balance' },
  ]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [searchQuery, setSearchQuery] = useState('');
  const [closingBalance, setClosingBalance] = useState('');

  const today = new Date();
  const formattedDate = today.toISOString().split('T')[0];

  React.useEffect(() => {
    setIsLoading(true);
    dispatch(GetSingleBank(id))
      .unwrap()
      .then((data) => {
        setIsLoading(false);
        setBankData(data?.data);
      })
      .catch(({ message }) => {
        setIsLoading(false);
        console.log(message);
          setBankData({});
      });
  }, [dispatch, id]);

 // Load saved financial year and dates from localStorage
const loadSavedDates = () => {
  const savedFinancialYear = localStorage.getItem('selectedFinancialYear');
  
  // Ensure financial year is always correctly structured
  let startYear, endYear;
  if (savedFinancialYear && savedFinancialYear.includes('-')) {
    [startYear, endYear] = savedFinancialYear.split('-');
  } else {
    // Default to the current financial year
    const currentYear = new Date().getFullYear();
    startYear = currentYear - 1; // Example: 2024 (for 2024-2025)
    endYear = currentYear;       // Example: 2025 (for 2024-2025)
  }

  return {
    financialYear: savedFinancialYear || `${startYear}-${endYear}`,
    fromDate: localStorage.getItem('savedFromDate') || `${startYear}-04-01`,
    toDate: localStorage.getItem('savedToDate') || `${endYear}-03-31`,
    minDate: `${startYear}-04-01`,
    maxDate: `${endYear}-03-31`,
  };
};


const { fromDate: initialFromDate, toDate: initialToDate, minDate, maxDate, financialYear: initialFinancialYear } = loadSavedDates();

const [fromDate, setFromDate] = useState(initialFromDate);
const [toDate, setToDate] = useState(initialToDate);
const [financialYear, setFinancialYear] = useState(initialFinancialYear);


useEffect(() => {
  if (!financialYear) return;

  localStorage.setItem('selectedFinancialYear', financialYear);

  let startYear, endYear;
  if (financialYear.includes('-')) {
    [startYear, endYear] = financialYear.split('-');
  } else {
    return; // Exit if financial year is not valid
  }

  const savedFromDate = localStorage.getItem('savedFromDate') || `${startYear}-04-01`;
  const savedToDate = localStorage.getItem('savedToDate') || `${endYear}-03-31`;

  setFromDate(savedFromDate);
  setToDate(savedToDate);

  if (!localStorage.getItem('savedFromDate')) localStorage.setItem('savedFromDate', savedFromDate);
  if (!localStorage.getItem('savedToDate')) localStorage.setItem('savedToDate', savedToDate);
}, [financialYear]);


  const fetchLedgerEntries = async () => {
    const newItem = {
      ...item,
      from_date: fromDate, // Ensure from_date is sent
      to_date: toDate, // Ensure to_date is sent
    };
    try {
      setIsLoading(true);
      const data = await dispatch(LedgerEntires(newItem)).unwrap();
      setLedgerEntires(data?.data?.entries);
      setClosingBalance(data?.data?.closing_balance);
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const resetDates = async () => {
    const storedFinancialYear = localStorage.getItem('selectedFinancialYear'); // Example: "2022-2023"
    
    let startYear, endYear;
    
    if (storedFinancialYear) {
      // Extract the start and end year from stored financial year
      [startYear, endYear] = storedFinancialYear.split('-');
    } else {
      // If not found, determine the current financial year dynamically
      const today = new Date();
      startYear = today.getMonth() + 1 >= 4 ? today.getFullYear() : today.getFullYear() - 1;
      endYear = parseInt(startYear) + 1;
    }
  
    const defaultFromDate = `${startYear}-04-01`;
    const defaultToDate = `${endYear}-03-31`;
  console.log(defaultFromDate,defaultToDate)
    // Update state
    setFromDate(defaultFromDate);
    setToDate(defaultToDate);
  
   localStorage.setItem('savedFromDate', defaultFromDate);
   localStorage.setItem('savedToDate', defaultToDate);
    // Create newItem with updated financial year

    // Call handleProfitLoss with updated values directly
    const newItem = {
      ...item,
      from_date: fromDate, // Ensure from_date is sent
      to_date: toDate, // Ensure to_date is sent
    };

    setIsLoading(true);

    try {
      setIsLoading(true);
      const data = await dispatch(LedgerEntires(newItem)).unwrap();
      setLedgerEntires(data?.data?.entries);
      setClosingBalance(data?.data?.closing_balance);
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    fetchLedgerEntries();
  }, [dispatch, NewID,financialYear]);

  const handleDateChange = (startDate, endDate) => {
    setFromDate(startDate);
    setToDate(endDate);

    // Save the selected dates to local storage with unique keys
    localStorage.setItem('profitLossFromDate', startDate);
    localStorage.setItem('profitLossToDate', endDate);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredledgerEntires = (ledgerEntires || [])?.filter((party) => {
    const search = searchQuery?.toLowerCase() || '';
    return (
      party?.description?.toLowerCase()?.includes(search) ||
      party?.added_on?.toLowerCase()?.includes(search) ||
      String(party?.dr || '')
        .toLowerCase()
        .includes(search) || // Safely convert to string
      String(party?.cr || '')
        .toLowerCase()
        .includes(search) || // Safely convert to string
      String(party?.closing_balance || '')
        .toLowerCase()
        .includes(search) // Safely convert to string
    );
  });

  const handleExcelDownload = () => {
    if (!ledgerEntires || ledgerEntires.length === 0) {
      alert('No data available for download.');
      return;
    }

    const selectedInvoices = selectAll && ledgerEntires.length > 0 ? ledgerEntires.map((invoice) => invoice.id) : selectedRows;

    if (!selectedInvoices || selectedInvoices.length === 0) {
      alert('Please select at least one BankBook.');
      return;
    }

    const selectedData = ledgerEntires.filter((invoice) => selectedInvoices.includes(invoice.id));

    if (selectedData.length === 0) {
      alert('No matching BankBook found.');
      return;
    }

    try {
      excelBankBookDownload(selectedData, 'BankBook.xlsx');
      toast.success('Downloading Excel file successfully!');
    } catch (error) {
      console.error('Error downloading Excel file:', error);
      alert('Failed to download the Excel file. Please try again.');
    }
  };


  const handleFromDateChange = (e) => {
    const newDate = e.target.value;
    if (newDate >= minDate && newDate <= maxDate) {
      setFromDate(newDate);
      localStorage.setItem('savedFromDate', newDate);
    } else {
         toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
    }
  };
  
  const handleToDateChange = (e) => {
    const newDate = e.target.value;
    if (newDate >= minDate && newDate <= maxDate) {
      setToDate(newDate);
      localStorage.setItem('savedToDate', newDate);
    } else {
         toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
    }
  };
  const formatFinancialYear = (startDate, endDate) => {
    return `(${startDate.split("-").reverse().join("-")} to ${endDate.split("-").reverse().join("-")})`;
  };

    const handlePdfDownload = async (e) => {
      if (e) e.preventDefault(); // Prevent default only if `e` is present
  
      const  {
        profile_id,
        ledger_id,
      }=item
      // console.log(item)
  
      setIsLoading(true);
  
      try {
        const data=`${API_BASE_URL}${API_PATHS.ledgerpdf}/${ledger_id}/${toDate}/${fromDate}/${profile_id}`
  
        if (data) {
          // console.log(data)
          navigate('/Pdf-Viewer', { state: { data } });
        }
      } catch (error) {
        toast.error('No Record Found!!');
        console.log(error.message);
      } finally {
        setIsLoading(false);
      }
    };
  return (
    <AdminLayout>
      {isLoading && <Loader />}
      <div className="row content-body">
        <div className="container-fluid">
          <div className="page-header">
            <div>
              <h2 class="main-content-title tx-24 mg-b-5 text-uppercase">{bankData?.bank_name}</h2>
              {/* <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="#">Home</a></li>
                                <li class="breadcrumb-item active" aria-current="page">List</li>
                            </ol> */}
            </div>
            <div class="d-flex justify-content-end">
              {/* <button
                      class="btn ripple btn-default"
                      onClick={() => {
                        navigate(`/bankbookEntry/${bankData.ledger_id ? bankData.ledger_id : null}`, { state: { data: bankData } });
                      }}
                    >
                      Deposit/Withdraw
                    </button> */}
              <button className="btn ripple btn-default" onClick={handleExcelDownload}>
                Export Excel <FaFileExcel />
              </button>
              <button className="btn ripple btn-default" onClick={handlePdfDownload}>
                Export Pdf <FaFilePdf />
              </button>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="card custom-card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-4 form-inline">
                          <div class="form-group">
                            <label class="font-weight-bold">Account Holder Name : </label>
                            <span>{bankData?.account_holder}</span>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div class="col-md-4 form-inline">
                          <div class="form-group">
                            <label class="font-weight-bold">Account No : </label>
                            <span>{bankData?.account_no}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col-md-12">
                  <div class="card custom-card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-3 form-inline">
                          <div class="form-group">
                            <label class="">From Date</label>
                            <input class="form-control" type="date"  value={fromDate} onChange={handleFromDateChange} min={minDate} max={maxDate} />
                          </div>
                        </div>
                        <div class="col-md-3 form-inline">
                          <div class="form-group">
                            <label class="">To Date</label>
                            <input class="form-control" type="date" value={toDate} onChange={handleToDateChange} min={minDate} max={maxDate}  />
                          </div>
                        </div>
                        <div class="col-md-5 form-inline">
                          <div class="form-group">
                            <button type="submit" class="btn btn-default" onClick={() => fetchLedgerEntries()}>
                              Submit
                            </button>
                          </div>
                          <div class="form-group">
                            <button type="button" className="btn btn-default" onClick={resetDates}>
                              Reset Date
                            </button>
                          </div>
                          <div class="form-group"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-md-12">
                  <Table
                    columns={columns}
                    data={filteredledgerEntires}
                    tableRef={tableRef}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    currentPage={currentPage}
                    totalCount={filteredledgerEntires?.length}
                    onPageChange={handlePageChange}
                    handleSearchChange={handleSearchChange}
                    closing_balance={closingBalance}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    selectAll={selectAll}
                    setSelectAll={setSelectAll}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default BankBook;
